import { motion } from "framer-motion";

const gradients = {
  blue: "from-blue-500 to-cyan-400",
  violet: "from-violet-500 to-purple-400",
  emerald: "from-emerald-500 to-teal-400",
  amber: "from-amber-500 to-orange-400",
  rose: "from-rose-500 to-pink-400",
};

const SectionHeading = ({ title, subtitle, gradient = "blue" }) => (
  <div className="mb-5 sm:mb-4">
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white transition-colors duration-300 font-display">
      {title}
    </h2>
    <motion.div
      className={`h-1 rounded-full bg-gradient-to-r ${gradients[gradient]} mt-3`}
      style={{ maxWidth: 120 }}
      initial={{ scaleX: 0, originX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
    />
    {subtitle && (
      <motion.p
        className="text-gray-500 dark:text-gray-400 text-sm mt-3 transition-colors duration-300"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        {subtitle}
      </motion.p>
    )}
  </div>
);

export default SectionHeading;
